import React from "react";
import { FilterComponent } from "./";

const Bluetable: FilterComponent = ({ id, height, width }) => (
  <filter
    colorInterpolationFilters="sRGB"
    filterUnits="objectBoundingBox"
    height={height}
    id={id}
    width={width}
    x={0}
    y={0}
  >
    <feComponentTransfer in="SourceGraphic">
      <feFuncR type="identity" />
      <feFuncG intercept="0.137" slope="0.862" type="linear" />
      <feFuncB intercept="0.474" slope="0.525" type="linear" />
      <feFuncA type="identity" />
    </feComponentTransfer>
  </filter>
);

export default Bluetable;
